export default {

    methods: {

        visuelConditions(condParams, line = null, page = null, itemData = null) {
            let arrayCond = [];
            if (!condParams || !Array.isArray(condParams)) return [];
            condParams.forEach((cond) => {


                switch (cond.type) {

                    case 'groupcond':

                        var returnCond = this.visuelConditions(cond.content, line, page, itemData);
                        //si condition ET et qu'une des condition n'est pas remplis on retourn false
                        if (cond.andor == 'and') {
                            if (returnCond.includes(false) || !returnCond.length) { arrayCond.push(false) } else { arrayCond.push(true); }
                        }
                        //si condition OU est qu'on ne trouve pas de condition remplis on retourne false
                        if (cond.andor == 'or') {
                            if (!returnCond.includes(true) || !returnCond.length) { arrayCond.push(false) } else { arrayCond.push(true); }
                        }
                        break;


                    case 'value':
                        var variableText = this.replaceVisuelItemVariables(cond.variable, itemData)
                        var valueText = this.replaceVisuelItemVariables(cond.value, itemData)
                        var variable = this.replaceBy({ text: variableText, page: page === null ? this.modalKey : page, line })
                        var value = this.replaceBy({ text: valueText, page: page === null ? this.modalKey : page, line })
                        switch (cond.condition) {
                            case 'value':
                                arrayCond.push(variable === value);
                                break;
                            case 'like':
                                arrayCond.push(variable.indexOf(value) != -1);
                                break;
                            case '!=':
                                arrayCond.push(variable != value);
                                break;
                            case '*':
                                arrayCond.push(variable != '' && variable != 'undefined');
                                break;
                            case 'null':
                                arrayCond.push(variable == 'null');
                                break;
                            case 'empty':
                                arrayCond.push(variable == '');
                                break;
                            case 'istrue':
                                arrayCond.push(variable === true);
                                break;
                            case 'isfalse':
                                arrayCond.push(variable === false);
                                break;
                            case 'issup':
                                if (!isNaN(parseInt(variable)) && !isNaN(parseInt(value))) {
                                    arrayCond.push(parseInt(variable) > parseInt(value));
                                }
                                break;
                            case 'isinf':
                                if (!isNaN(parseInt(variable)) && !isNaN(parseInt(value))) {
                                    arrayCond.push(parseInt(variable) < parseInt(value));
                                }
                                break;
                            case 'isequal':
                                arrayCond.push(variable == value);
                                break;
                            default:
                                arrayCond.push(false);
                        }
                        break;
                }

            })
            return arrayCond;
        },

        replaceVisuelItemVariables(value, itemData) {
            if (typeof value !== 'string' || !value.includes('[[item||')) return value

            return value.replace(/\[\[item\|\|([^\]]+)\]\]/g, (match, path) => {
                if (path === 'index') {
                    return itemData && itemData.__index !== undefined ? String(itemData.__index) : ''
                }
                if (path === 'value') {
                    if (itemData === null || itemData === undefined) return ''
                    if (typeof itemData === 'object' && Object.prototype.hasOwnProperty.call(itemData, 'value')) {
                        return itemData.value === null || itemData.value === undefined ? '' : String(itemData.value)
                    }
                    return typeof itemData === 'object' ? '' : String(itemData)
                }

                const resolved = String(path).split(/[. ]/).filter(Boolean).reduce((current, key) => (
                    current !== null && current !== undefined ? current[key] : undefined
                ), itemData)
                return resolved === null || resolved === undefined ? '' : String(resolved)
            })
        }

    }

}
